export const STATSIG_EVENT_NAMES = {
    CHECKOUT_ALL_ABANDON_ORDER_CLICK: 'Checkout - All - Click - Abandon Order',
    CHECKOUT_ALL_CART_SUMMARY_CLICK: 'Checkout - All - Click - Cart Summary',
    CHECKOUT_ALL_SUCCESS_ABANDON_ORDER:
        'Checkout - All - Sucsess - Abandon Order',

    CHECKOUT_STEP_END_CHECKOUT_FORM_VIEW:
        'Checkout - Checkout Step - View - End Checkout Form',
    CHECKOUT_STEP_ORDER_SUCCESS:
        'Checkout - Checkout Step - Success - Place Order',
    CHECKOUT_STEP_PAGE_VIEW: 'Checkout - Checkout Step - View - Page',
    CHECKOUT_STEP_PAYMENT_SELECTION_CLICK:
        'Checkout - Checkout Step - Click - Payment Selection',
    CHECKOUT_STEP_PLACE_ORDER_CLICK:
        'Checkout - Checkout Step - Click - Place Order',
    CHECKOUT_STEP_TRUST_MESSAGE_VIEW:
        'Checkout - Checkout Step - View - Trust Message',
    CHECKOUT_STEP_ORDER_CONFIRMATION_VIEW_PAGE:
        'Checkout - Order Confirmation Step - View - Page',
    CHECKOUT_STEP_ORDER_CONFIRMATION_VIEW_TICKETS:
        'Checkout - Order Confirmation Step - Click - View Tickets',

    CHECKOUT_STEP_SUCCESS_ORGANIZER_QUESTIONS_RATIO:
        'Checkout - Order Form - Success - Organizers Questions Submitted',
    CHECKOUT_STEP_ORGANIZER_QUESTIONS_VIEW:
        'Checkout - Organizer Additional Questions - View - Page',
    CHECKOUT_STEP_ORGANIZER_QUESTIONS_CLICK:
        'Checkout - Organizer Additional Questions - Click - Submit CTA',

    CHECKOUT_STEP_QUESTIONS_MODAL_VIEW:
        'Checkout - Checkout Step - View - Questions Modal',
    CHECKOUT_STEP_QUESTIONS_MODAL_CLICK:
        'Checkout - Checkout Step - Click - Questions Modal CTA',
    CHECKOUT_STEP_QUESTIONS_MODAL_CLOSE:
        'Checkout - Checkout Step - Click - Questions Modal Close',

    TICKET_STEP_PAGE_VIEW: 'Checkout - Ticket Selection Step - View - Page',
    TICKET_STEP_CONTINUE_TO_PAYMENT_CLICK:
        'Checkout - Ticket Selection Step - Click - Continue to payment',
    TICKET_STEP_CHANGE_TICKET_QUANTITY:
        'Checkout - Ticket Selection Step - Change - Ticket Quantity',
    TICKET_STEP_VALIDATION_ERROR_VIEW:
        'Checkout - Ticket Selection Step - View - Validation Error',
    TICKET_SELECTION_STEP_REMOVE_PROMO_CODE:
        'Checkout - Ticket Selection Step - Click - Remove Promo Code',
    TICKET_SELECTION_STEP_APPLY_PROMO_CODE:
        'Checkout - Ticket Selection Step - Click - Apply Promo Code',
    TICKET_SELECTION_STEP_ERROR_PROMO_CODE:
        'Checkout - Ticket Selection Step - View - Promo Code Error',
    TICKET_SELECTION_COMPACT_STEP_MORE_INFO_CLICK:
        'Listing - Conversion Bar - More info Button - Change - Compact Ticket Selection',
    TICKET_SELECTION_COMPACT_STEP_TICKET_QUANTITY_CLICK:
        'Listing - Conversion Bar - Ticket Quantity - Change - Compact Ticket Selection',

    LOGIN_STEP_PAGE_VIEW: 'Checkout - Login Step - View - Page',
    LOGIN_STEP_SUCCESS_LOGIN: 'Checkout - Login Step - Success - Button Login',
};

export enum TrustMessageText {
    NO_MESSAGE = 'no_message',
    VARIANT_TRANSACTION_SAFE = 'transactions_safe',
    VARIANT_PEOPLE_SECURELY_ORDER = 'people_securely_order',
}

export const TRUST_MESSAGE_EXPERIMENT = {
    defaultValue: TrustMessageText.NO_MESSAGE,
    name: 'checkout_trust_message',
    param: 'trust_message_copy',
};

const TICKET_SELECTION_PAGE_EXPERIMENTS_LAYER =
    'checkout_ticket_selection_page_experiments';

export const EXPRESS_CHECKOUT_CTA_COPY_EXPERIMENT = {
    defaultValue: false,
    layer: TICKET_SELECTION_PAGE_EXPERIMENTS_LAYER,
    param: 'has_checkout_cta_in_express_checkout',
};

export enum TicketsPageButtonEnabledCriteria {
    ifValid = 'if-valid',
    always = 'always',
}

export const ALWAYS_ENABLE_TICKETS_PAGE_BUTTON_LAYER_EXPERIMENT = {
    defaultValue: TicketsPageButtonEnabledCriteria.ifValid,
    layer: TICKET_SELECTION_PAGE_EXPERIMENTS_LAYER,
    param: 'enable_tickets_page_button',
};

const CHECKOUT_PAGE_EXPERIMENTS_LAYER = 'checkout_checkout_page_experiments';

export const UPDATE_DATE_FORMAT_EXPERIMENT = {
    defaultValue: false,
    layer: TICKET_SELECTION_PAGE_EXPERIMENTS_LAYER,
    param: 'updated_date_format',
};

export enum PromoCodeFieldVisibilityCriteria {
    whenClicked = 'whenClicked',
    always = 'always',
}

export const PROMO_CODE_EXPERIMENT = {
    defaultValue: PromoCodeFieldVisibilityCriteria.whenClicked,
    layer: TICKET_SELECTION_PAGE_EXPERIMENTS_LAYER,
    param: 'promo_code_field_visible',
};

export enum TicketsFormat {
    listItem = 'listItem',
    card = 'card',
}
export const TICKETS_AS_INDIVIDUAL_CARDS_EXPERIMENT = {
    defaultValue: TicketsFormat.listItem,
    layer: TICKET_SELECTION_PAGE_EXPERIMENTS_LAYER,
    param: 'tickets_format',
};

export enum OrderFormFormat {
    onePage = 'onePage',
    twoPages = 'twoPages',
}
export const ORDER_FORM_SPLITTED_IN_TWO_PAGES_EXPERIMENT = {
    defaultValue: OrderFormFormat.onePage,
    layer: CHECKOUT_PAGE_EXPERIMENTS_LAYER,
    param: 'order_form_format',
};

export const URGENCY_SIGNALS_ON_TICKET_SELECTION_PAGE_EXPERIMENT = {
    defaultValue: false,
    layer: TICKET_SELECTION_PAGE_EXPERIMENTS_LAYER,
    param: 'urgency_signals_visible',
};

// Important: Don't forget to add any new experiment to this object.
// This object is used by Cypress to force control in all experiments by default.
// If you don't add new experiments to this object, tests will become flaky when the experiment starts.
export const STATSIG_PARAMETERS_FOR_ALL_EXPERIMENTS_IN_CONTROL = {
    [TRUST_MESSAGE_EXPERIMENT.param]: TRUST_MESSAGE_EXPERIMENT.defaultValue,
    [ALWAYS_ENABLE_TICKETS_PAGE_BUTTON_LAYER_EXPERIMENT.param]:
        ALWAYS_ENABLE_TICKETS_PAGE_BUTTON_LAYER_EXPERIMENT.defaultValue,
    [UPDATE_DATE_FORMAT_EXPERIMENT.param]:
        UPDATE_DATE_FORMAT_EXPERIMENT.defaultValue,
    [PROMO_CODE_EXPERIMENT.param]: PROMO_CODE_EXPERIMENT.defaultValue,
    [TICKETS_AS_INDIVIDUAL_CARDS_EXPERIMENT.param]:
        TICKETS_AS_INDIVIDUAL_CARDS_EXPERIMENT.defaultValue,
    [ORDER_FORM_SPLITTED_IN_TWO_PAGES_EXPERIMENT.param]:
        ORDER_FORM_SPLITTED_IN_TWO_PAGES_EXPERIMENT.defaultValue,
    [EXPRESS_CHECKOUT_CTA_COPY_EXPERIMENT.param]:
        EXPRESS_CHECKOUT_CTA_COPY_EXPERIMENT.defaultValue,
    [URGENCY_SIGNALS_ON_TICKET_SELECTION_PAGE_EXPERIMENT.param]:
        URGENCY_SIGNALS_ON_TICKET_SELECTION_PAGE_EXPERIMENT.defaultValue,
};
